<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
           <loading
                :active.sync="loading"
                :can-cancel="false"
                :is-full-page="true"
          ></loading>

    <b-card class="bCardGlobal">
      <div class="divSubtitulo d-flex justify-content-between">
        <p class="textoSubtitulo">Comisiones a partir de abril 2024 para OGs y 2da quincena octubre 2024 para ortodoncistas</p>
        <p class="textoSubtitulo">CÓDIGO</p>
      </div>

      <div class="d-flex justify-content-start mt-4 w-100 mb-5">
        <div v-for="(tab, index) in opciones" v-bind:key="index">
          <div
            class="d-flex justify-content-center flex-column pr-4 pt-2"
            v-if="
              $localStorageService.can(tab.permiso)
            "
            :class="active == index ? 'active' : 'default-tab'"
            @click="tabSeleccionada = index"
            style="min-width: max-content"
          >
            <p
              class="m-0 text-center"
              :class="tabSeleccionada == index ? '' : 'mb-2'"
            >
              {{ tab.descripcion }}
            </p>
            <hr
              v-if="tabSeleccionada == index"
              class="w-50 mx-auto m-0 p-0 mt-2"
              style="height: 0.08em; background-color: #83bee8"
            />
          </div>
        </div>
      </div>


      <div v-if="tabSeleccionada == 0 && $localStorageService.can('NuevaComisionDashboard')" class="pt-3"> 
        
        <p class="text-left" style="font-weight: bold; color: #0069A9;">Histórico de comisiones ({{periodoInicial}})</p>

        <b-row class="d-flex justify-content-between w-100">
          <b-col lg="6" md="12" sm="12">
            <div class="barras d-flex justify-content-center w-100" v-if="$localStorageService.can('filtro_dr_comision')" style="margin-top: 10px" ><!--  -->
              <b-form-input
                  class="input-filter"
                  v-model="buscadorHistorico"
                  placeholder="Búsqueda de doctor por nombre"
                  type="text"
                  @keydown.enter.native="buscarEmpleados(1)"
              >
              </b-form-input>
              <b-button class="btn-extra-small" variant="info" @click="buscarEmpleados(1)">
                              <span>
                                <em class="buscar_svg" style="margin-top: 3px; height: 13px">
                                </em
                                ></span>
              </b-button>
            </div>

            <b-table
            v-if="doctores.length > 0"
            style="border-radius: 10px"
            :fields="fields"
            :items="doctores"
            :per-page="registrosDrPorPagina"
            :current-page="paginaActualDr"
            selectable
            @row-selected="buscarComisionesHistorico"
            responsive
          >
          </b-table>
          <b-pagination
                  v-if="doctores.length >= registrosDrPorPagina"
                  align="center"
                  v-model="paginaActualDr"
                  :total-rows="doctores.length"
                  :per-page="registrosDrPorPagina"
            ></b-pagination>
        
          </b-col>
          <b-col lg="6" md="12" sm="12" class="d-flex justify-content-end">
            <div class="d-flex justify-content-between pl-3 pr-3 pt-1 mt-2 w-50" v-if="$localStorageService.can('NuevaComisionFiltroaDashboard')" style="height: 4vh; padding-top: auto; padding-bottom: 1%; background-color: #EBF9FF; border-radius: 20px;">
            <em class="filtros_svg" style="width: 15px;"></em>
            <div class="d-flex align-items-center" style="min-height: 20px;">
            
              <div class="text-center">
                <div>
                  <a :class="nombreTiempoSeleccionado != '' ? 'filtroActivo' : 'filtroInactivo'" @click.prevent v-b-tooltip.hover title="Filtrar por tiempo: Se mostraran los registros que su fecha de producción coincida con la fecha seleccionada" id="popover-button-variant" href="#" tabindex="0">Mes producción</a>
                  <em :class="showPopoverTiempo ? 'rotate-chevron' : ''" class="arrow_down_svg chevron-gris ml-2" style="width: 13px;"></em>
                </div>
                <b-popover target="popover-button-variant" variant="light" triggers="focus">
                  <div class="p-2">
                    <b-form-group v-if="tipoTiempo == 2 || tipoTiempo == 1" class="text-left">
                      <label>Mes</label>
                      <b-form-select
                          :options="listaMeses"
                          v-model="mesPeriodo"
                          text-field="nombreMes"
                          value-field="idMes">
                      </b-form-select>
                    </b-form-group>
                    <b-form-group v-if="tipoTiempo == 1 || tipoTiempo == 2 " class="text-left">
                      <label>Año</label>
                      <b-form-select
                          :options="anios"
                          v-model="anioPeriodo"
                      >
                      </b-form-select>
                    </b-form-group>
                  </div>
                  <div class="text-center">
                    <b-button variant="outline-info" @click="obtenerHistorico(false, 2)" size="sm">Aplicar</b-button>
                  </div>
                </b-popover>
              </div>

              <!-- <div id="mesProduccion" class="d-flex ml-4" @click="mostrarTiempos()" >
                
              </div> -->
              <b-popover target="mesProduccion" triggers="click blur" placement="bottom" style="min-width: 300px !important;" :show.sync="showPopoverTiempo">

                <div class="p-2">
                  <b-form-group v-if="tipoTiempo == 2 || tipoTiempo == 1" class="text-left">
                    <label>Mes</label>
                    <b-form-select
                        :options="listaMeses"
                        v-model="mesPeriodo"
                        text-field="nombreMes"
                        value-field="idMes">
                    </b-form-select>
                  </b-form-group>
                  <b-form-group v-if="tipoTiempo == 1 || tipoTiempo == 2 " class="text-left">
                    <label>Año</label>
                    <b-form-select
                        :options="anios"
                        v-model="anioPeriodo"
                    >
                    </b-form-select>
                  </b-form-group>
                </div>
                <div class="text-center">
                  <b-button variant="outline-info" @click="obtenerHistorico()" size="sm">Aplicar</b-button>
                </div>
              </b-popover>
              <b-button v-if="nombreTiempoSeleccionado != ''" class="ml-3 boton-inv-filtro" variant="primary" v-b-tooltip.hover title="Ver detalle" @click="limpiarFiltros()">
                <em class="close_x_svg icon-boton-filtro"></em> 
            </b-button>
            </div>
        </div>
          </b-col>
        </b-row>


        <div class="container-comision">
          <div>
            <div v-if="nivelPuestoIDHistorico == 42" class="mt-5 w-100 pl-4 pt-2 pb-1" style="font-weight: 600;">
              <b-row class="w-100" style="font-size: .8em;">
                <b-col lg="2" md="2" sm="12">Concepto</b-col>
                <b-col lg="2" md="2" sm="12">
                  <b-row>
                    <b-col lg="12" class="mb-1 custom-class-for-sm d-sm-block" style="">Tratamientos realizados</b-col>
                    <b-col >Desde</b-col>
                    <b-col>Hasta</b-col>
                  </b-row>
                </b-col>
                <b-col lg="2" md="2" sm="12">Periodo</b-col>
                <b-col lg="1" md="2" sm="12">Monto bruto</b-col>
                <b-col lg="2" md="2" sm="12">Ganador</b-col>
                <b-col lg="2" md="2" sm="12">Fecha de pago</b-col>
                <b-col lg="1" md="2" sm="12"></b-col>
              </b-row>
              <hr>
            </div>

            <div v-if="nivelPuestoIDHistorico == 38 && ortodoncistaHistorico == false && (tierHistorico == 1 || tierHistorico == 2)" class="mt-5 w-100 pl-4 pt-2 pb-1" style="font-weight: 600;">
              <b-row class="w-100" style="font-size: .8em;">
                <b-col lg="2" md="2" sm="12">
                  <b-row>
                    <b-col lg="12" class="mb-1 custom-class-for-sm d-sm-block" style="">Tratamientos realizados</b-col>
                    <b-col >Desde</b-col>
                    <b-col>Hasta</b-col>
                  </b-row>
                </b-col>
                <b-col lg="2" md="2" sm="12">Periodo</b-col>
                <b-col lg="2" md="2" sm="12">Comisiones</b-col>
                <b-col lg="2" md="2" sm="12">Bono especial</b-col>
                <b-col lg="2" md="2" sm="12">Total</b-col>
                <b-col lg="2" md="2" sm="12">Fecha de pago</b-col>
              </b-row>
              <hr>
            </div>

            <div v-if="nivelPuestoIDHistorico == 38 && ortodoncistaHistorico == false && (tierHistorico == 3 || tierHistorico == null)" class="mt-5 w-100 pl-4 pt-2 pb-1" style="font-weight: 600;">
              <b-row class="w-100" style="font-size: .8em;">
                <b-col lg="3" md="2" sm="12">
                  <b-row>
                    <b-col lg="12" class="mb-1 custom-class-for-sm d-sm-block" style="">Tratamientos realizados</b-col>
                    <b-col >Desde</b-col>
                    <b-col>Hasta</b-col>
                  </b-row>
                </b-col>
                <b-col lg="3" md="2" sm="12">Periodo</b-col>
                <b-col lg="3" md="2" sm="12">Comisiones</b-col>
                <b-col lg="3" md="2" sm="12">Fecha de pago</b-col>
              </b-row>
              <hr>
            </div>

            <div v-if="nivelPuestoIDHistorico == 38 && ortodoncistaHistorico == true && (tierHistorico == 1 || tierHistorico == 2)" class="mt-5 w-100 pl-4 pt-2 pb-1" style="font-weight: 600;">
              <b-row class="w-100" style="font-size: .8em;">
                <b-col lg="2" md="2" sm="12">
                  <b-row>
                    <b-col lg="12" class="mb-1 custom-class-for-sm d-sm-block" style="">Tratamientos realizados</b-col>
                    <b-col >Desde</b-col>
                    <b-col>Hasta</b-col>
                  </b-row>
                </b-col>
                <b-col lg="2" md="2" sm="12">Periodo</b-col>
                <b-col lg="2" md="2" sm="12">Ganador</b-col>
                <b-col lg="1" md="1" sm="12">Monto ganador</b-col>
                <b-col lg="1" md="1" sm="12">Bono especial</b-col>
                <b-col lg="1" md="2" sm="12">Bono referenciación</b-col>
                <b-col lg="1" md="2" sm="12">Total</b-col>
                <b-col lg="2" md="2" sm="12">Fecha de pago</b-col>
              </b-row>
              <hr>
            </div>
            
            <div v-if="nivelPuestoIDHistorico == 38 && ortodoncistaHistorico == true && (tierHistorico == 3 || tierHistorico == null)" class="mt-5 w-100 pl-4 pt-2 pb-1" style="font-weight: 600;">
              <b-row class="w-100" style="font-size: .8em;">
                <b-col lg="" md="2" sm="12">
                  <b-row>
                    <b-col lg="12" class="mb-1 custom-class-for-sm d-sm-block" style="">Tratamientos realizados</b-col>
                    <b-col >Desde</b-col>
                    <b-col>Hasta</b-col>
                  </b-row>
                </b-col>
                <b-col lg="2" md="2" sm="12">Periodo</b-col>
                <!-- <b-col lg="2" md="2" sm="12">Ganador</b-col> -->
                <b-col lg="2" md="2" sm="12">Bono productividad</b-col>
                <b-col lg="2" md="2" sm="12">Fecha de pago</b-col>
              </b-row>
              <hr>
            </div>

            <div>
              <div v-if="datosResumenComisiones != null && datosResumenComisiones.length == 0" class="d-flex justify-content-center align-items-center" style="min-height: 300px;">
                <p>No se encontraron registros</p>
              </div>
              <div v-else style="min-height: 300px;">

                <div v-if="nivelPuestoIDHistorico == 42">
                  <div v-for="(mes, nombreMes) in datosAgrupadosOG" :key="nombreMes">
                  <p class="text-left" style="font-weight: 600; font-size: 1em; color: #0069A9">{{ nombreMes }}</p>
                <div :class="{'cardCerradaEnCurso': comision.periodoActual && !comision.cardColapsada, 'cardAbierta': comision.cardColapsada}" v-for="(comision, index) in mes" v-bind:key="index" class="mb-2" style="border: 1px solid #E8E8E8; border-radius: 15px; min-height: 75px;">
                  <div v-if="comision.periodoActual" class="pt-1 pb-1" style="left: 0px; top: 0px; border-radius: 15px 0px 15px 0px; background-color: #74D57D; color: white; width: 7%; font-size: 11px; font-weight: 500;">En curso</div>
                      <b-row class="w-100 w-100 pl-4 pt-3 pb-4" :class="comision.periodoActual ? 'margenPeriodoActual' : 'mt-3'" style="font-size: .8em;">
                      <b-col lg="2" md="2">{{comision.CONCEPTO}}</b-col>
                      <b-col>{{comision.DESDE}}</b-col>
                      <b-col>{{comision.HASTA}}</b-col>
                      <b-col lg="2" md="2">{{comision.PERIODO}}</b-col>
                      <b-col lg="1" md="2">{{comision.GANADOR != null ? formatoMoneda(comision.MONTO_BRUTO) : formatoMoneda(comision.COMISION_POR_BONO)}}</b-col>
                      <b-col lg="2" md="2">{{comision.GANADOR != null ? comision.GANADOR : 'N/A'}}</b-col>
                      <b-col lg="2" md="2">{{comision.FECHA_PAGO}}</b-col>
                      <b-col lg="1" md="2">
                        <b-button class="boton-inv botonDetalle" variant="primary" v-b-tooltip.hover title="Ver detalle" v-b-toggle="`${nombreMes}-${index}`" @click="crearGraficaBarraHorizontal(index, comision, nombreMes)">
                          <em class="blue_eye_comision icon-boton"></em> 
                      </b-button>
                      </b-col>
                    </b-row>
                    <b-collapse :id="`${nombreMes}-${index}`" v-model="comision.cardColapsada" class="mx-auto align-items-center" style="min-height: 200px;">
                      <hr>
                      <div v-if="comision.GANADOR == null" style="font-size: .8em;">
                        <p>El bono se paga a partir del 80% de la meta. Si se excede del 100% se sigue pagando</p>
                        <p>En caso de cumplir con el bono, se te pagará el 0.15% del ingreso de clínica</p>
                      </div>
                      <b-row class="pl-2 pr-2 pb-2">
                        <b-col>
                          <div class="p-2" style="border-radius: 15px; border: 1px solid #D9D9D9;">
                            <p v-if="comision.GANADOR != null" class="text-left" style="font-size: .9em; font-weight: 500; color: #1BA595;">Ingreso productividad vs ingreso fijo</p>
                            <canvas v-if="comision.GANADOR != null" :id="'bar-chart-horizontal' + nombreMes + index" width="300" height="100"></canvas>

                            <div v-if="comision.GANADOR == null">
                              <p class="text-left" style="color: #1BA595; font-weight: 500;">Bono de clínica vs meta ({{formatoMes(comision.HASTA)}})</p>
                              <b-row class="pr-2">
                                <b-col lg="6" md="6">
                                  <Medidor :percentage="comision.CUMPLIMIENTO_CLINICA" :metaClinica="comision.META_BONO_CLINICA"/>
                                </b-col>
                                <b-col lg="6" md="6" class="d-flex justify-content-center align-items-center flex-column">
                                  <p style="font-weight: 700; font-size: 1.1em;" :class="comision.CUMPLIMIENTO_CLINICA < 80 && comision.GANADOR == null ? 'colorPagoSinCumplir' : 'colorPagoCumplido'">{{redondeoPorcentaje(comision.CUMPLIMIENTO_CLINICA)}}% de avance</p>
                                  <p style="font-weight: 500; font-size: .9em; color: rgb(124, 124, 124)">{{formatoMoneda(comision.INGRESO_CLINICA)}}</p>
                                </b-col>
                              </b-row>
                            </div>
                          </div>
                          
                        </b-col>
                        <b-col lg="3" md="3" :class="comision.GANADOR == null ? 'mt-5' : 'mt-2'">
                          <div class="p-2" style="border-radius: 15px; min-height: 140px; border: 1px solid #D9D9D9;">
                            <p class="text-left colorPagoCumplido" style="font-weight: 500; font-size: .9em;">Pago por {{comision.GANADOR == null ? comision.CONCEPTO : comision.GANADOR}}</p>
                            <div class="d-flex justify-content-center mt-4">
                              <em class="pago_comision mr-2" :class="comision.CUMPLIMIENTO_CLINICA < 80 && comision.GANADOR == null ? 'iconoSinCumplir' : ''"></em>
                              <p v-if="comision.CUMPLIMIENTO_CLINICA < 80 && comision.GANADOR == null && comision.periodoActual" class="colorPagoSinCumplir mt-3" style="font-weight: 600;">No se ha cumplido la meta</p>
                              <p v-else-if="comision.CUMPLIMIENTO_CLINICA < 80 && comision.GANADOR == null" class="colorPagoSinCumplir mt-3" style="font-weight: 600;">No se cumplió la meta</p>
                              <p v-if="comision.CUMPLIMIENTO_CLINICA >= 80 && comision.GANADOR == null" style="font-weight: 600;" class="mt-3 colorPagoCumplido">{{formatoMoneda(comision.COMISION_POR_BONO)}}</p>
                              <p v-if="comision.GANADOR != null" class="text-center colorPagoCumplido mt-3" style="font-weight: 600;">{{formatoMoneda(comision.MONTO_BRUTO)}}</p>
                              
                            </div>
                          </div>
                        </b-col>
                        <b-col lg="3" md="3" :class="comision.GANADOR == null ? 'mt-5' : 'mt-2'">
                          <div class="p-2" style="border-radius: 15px; min-height: 140px; border: 1px solid #D9D9D9;">
                            <p class="text-left colorFechaPagoCumplido" style="font-weight: 500; font-size: .9em;">Fecha de pago</p>
                            <div class="d-flex justify-content-center mt-4">
                              <em class="fecha_pago mr-2" :class="comision.CUMPLIMIENTO_CLINICA < 80 && comision.GANADOR == null ? 'iconoSinCumplir' : ''"></em>
                              <p v-if="comision.CUMPLIMIENTO_CLINICA < 80 && comision.GANADOR == null && comision.periodoActual" style="font-weight: 600;" class="mt-3 colorPagoSinCumplir">No se ha cumplido la meta</p>
                              <p v-else-if="comision.CUMPLIMIENTO_CLINICA < 80 && comision.GANADOR == null" style="font-weight: 600;" class="mt-3 colorPagoSinCumplir">No se cumplió la meta</p>
                              <p v-else style="font-weight: 600;" class="mt-3 colorFechaPagoCumplido">{{comision.FECHA_PAGO}}</p>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-collapse>
                  </div>
                </div>
                </div>

                <div v-if="nivelPuestoIDHistorico == 38 && ortodoncistaHistorico == false && (tierHistorico == 1 || tierHistorico == 2)">
                  <div v-for="(mes, nombreMes) in datosAgrupadosEspecialistas" :key="nombreMes">
                    <p class="text-left" style="font-weight: 600; font-size: 1em; color: #0069A9">{{ nombreMes }}</p>
                    <div v-for="(comision, index) in mes" :key="index" class="mb-2" :class="comision.periodoActual ? 'cardCerradaEnCurso pb-4' : 'cardCerrada d-flex align-items-center'" style="border: 1px solid #E8E8E8; border-radius: 15px; min-height: 75px;">
                      <div v-if="comision.periodoActual" class="pt-1 pb-1" style="left: 0px; top: 0px; border-radius: 15px 0px 15px 0px; background-color: #74D57D; color: white; width: 7%; font-size: 11px; font-weight: 500;">En curso</div>
                        <b-row class="w-100 w-100 pl-4" :class="comision.periodoActual ? 'pt-2' : ''"  style="font-size: .9em;">
                          <b-col lg="1">{{ comision.desde }}</b-col>
                          <b-col lg="1">{{ comision.hasta }}</b-col>
                          <b-col lg="2">{{ comision.periodo }}</b-col>
                          <b-col lg="2">{{ formatoMoneda(comision.COMISIONES) }}</b-col>
                          <b-col lg="2">{{ formatoMoneda(comision.bonoEspecial) }}</b-col>
                          <b-col lg="2">{{ formatoMoneda(comision.COMISIONES + comision.bonoEspecial) }}</b-col>
                          <b-col lg="2">{{ comision.fechaPago }}</b-col>
                        </b-row>
                    </div>
                  </div>
                </div>

                <div v-if="nivelPuestoIDHistorico == 38 && ortodoncistaHistorico == false && (tierHistorico == 3 || tierHistorico == null) ">
                  <div v-for="(mes, nombreMes) in datosAgrupadosEspecialistas" :key="nombreMes">
                    <p class="text-left" style="font-weight: 600; font-size: 1em; color: #0069A9">{{ nombreMes }}</p>
                    <div v-for="(comision, index) in mes" :key="index" class="mb-2" :class="comision.periodoActual ? 'cardCerradaEnCurso pb-4' : 'cardCerrada d-flex align-items-center'" style="border: 1px solid #E8E8E8; border-radius: 15px; min-height: 75px;">
                      <div v-if="comision.periodoActual" class="pt-1 pb-1" style="left: 0px; top: 0px; border-radius: 15px 0px 15px 0px; background-color: #74D57D; color: white; width: 7%; font-size: 11px; font-weight: 500;">En curso</div>
                        <b-row class="w-100 w-100 pl-4" :class="comision.periodoActual ? 'pt-2' : ''"  style="font-size: .9em;">
                          <b-col cols="3">
                            <b-row>
                              <b-col>{{ comision.desde }}</b-col>
                              <b-col>{{ comision.hasta }}</b-col>
                            </b-row>
                          </b-col>
                          <b-col cols="3">{{ comision.periodo }}</b-col>
                          <b-col cols="3">{{ formatoMoneda(comision.COMISIONES) }}</b-col>
                          <b-col cols="3">{{ comision.fechaPago }}</b-col>
                        </b-row>
                    </div>
                  </div>
                </div>
                
                <div v-if="nivelPuestoIDHistorico == 38 && ortodoncistaHistorico == true && (tierHistorico == 1 || tierHistorico == 2)">
                  <div v-for="(mes, nombreMes) in datosAgrupadosEspecialistas" :key="nombreMes">
                    <p class="text-left" style="font-weight: 600; font-size: 1em; color: #0069A9">{{ nombreMes }}</p>
                    <div v-for="(comision, index) in mes" :key="index" class="mb-2" :class="{'cardCerradaEnCurso ': comision.periodoActual && !comision.cardColapsada, 'cardAbierta': comision.cardColapsada}" style="border: 1px solid #E8E8E8; border-radius: 15px; min-height: 75px;">
                      <div v-if="comision.periodoActual" class="pt-1 pb-1" style="left: 0px; top: 0px; border-radius: 15px 0px 15px 0px; background-color: #74D57D; color: white; width: 7%; font-size: 11px; font-weight: 500;">En curso</div>
                       <div class="d-flex align-items-center" :style="!comision.periodoActual ? 'min-height: 74px;' : 'margin-top: 7px;'">
                        <b-row class="w-100 w-100 pl-4" style="font-size: .8em;">
                          <b-col lg="1">{{ comision.desde }}</b-col>
                          <b-col lg="1">{{ comision.hasta }}</b-col>
                          <b-col lg="2">{{ comision.periodo }}</b-col>
                          <b-col lg="2">{{ comision.ganador }}</b-col>
                          <b-col lg="1">{{ formatoMoneda(comision.SALARIO_FIJO > comision.COMISIONES ? comision.SALARIO_FIJO : comision.COMISIONES) }}</b-col>
                          <b-col lg="1">{{ formatoMoneda(comision.bonoEspecial) }}</b-col>
                          <b-col lg="1">{{ formatoMoneda( comision.bonoReferenciacion) }}</b-col>
                          <b-col lg="1">{{ formatoMoneda(comision.SALARIO_FIJO > comision.COMISIONES ? (comision.SALARIO_FIJO + comision.bonoEspecial + comision.bonoReferenciacion) : (comision.COMISIONES + comision.bonoEspecial + comision.bonoReferenciacion)) }}</b-col>
                          <b-col lg="2">{{ comision.fechaPago }}</b-col>
                        </b-row>
                        <b-button class="boton-inv botonDetalle" style="margin-left: -2%;" variant="primary" v-b-tooltip.hover title="Ver detalle" v-b-toggle="`${nombreMes}-${index}`" @click="crearGraficaBarraHorizontal(index, comision, nombreMes)">
                          <em class="blue_eye_comision icon-boton"></em> 
                        </b-button>
                       </div>
                        
                        <div>
                          <b-collapse :id="`${nombreMes}-${index}`" v-model="comision.cardColapsada" class="mx-auto align-items-center" style="min-height: 200px;">
                          <b-row class="pl-2 pr-2 pb-2">
                            <b-col cols="6">
                              <div class="p-2" style="border-radius: 15px; border: 1px solid #D9D9D9;">
                                <p v-if="comision.ganador != null" class="text-left" style="font-size: .9em; font-weight: 500; color: #1BA595;">Ingreso productividad vs ingreso fijo</p>
                                <canvas v-if="comision.ganador != null" :id="'bar-chart-horizontal' + nombreMes + index" width="300" height="100"></canvas>

                                <div v-if="comision.ganador == null">
                                  <p class="text-left" style="color: #1BA595; font-weight: 500;">Bono de clínica vs meta ({{formatoMes(comision.HASTA)}})</p>
                                  <b-row class="pr-2">
                                    <b-col lg="6" md="6">
                                      <Medidor :percentage="comision.CUMPLIMIENTO_CLINICA" :metaClinica="comision.META_BONO_CLINICA"/>
                                    </b-col>
                                    <b-col lg="6" md="6" class="d-flex justify-content-center align-items-center flex-column">
                                      <p style="font-weight: 700; font-size: 1.1em;" :class="comision.CUMPLIMIENTO_CLINICA < 80 && comision.ganador == null ? 'colorPagoSinCumplir' : 'colorPagoCumplido'">{{redondeoPorcentaje(comision.CUMPLIMIENTO_CLINICA)}}% de avance</p>
                                      <p style="font-weight: 500; font-size: .9em; color: rgb(124, 124, 124)">{{formatoMoneda(comision.INGRESO_CLINICA)}}</p>
                                    </b-col>
                                  </b-row>
                                </div>
                              </div>
                            </b-col>
                      </b-row>
                        </b-collapse>
                        </div>
                    </div>
                  </div>
                </div>

                <div v-if="nivelPuestoIDHistorico == 38 && ortodoncistaHistorico == true && (tierHistorico == 3 || tierHistorico == null)">
                  <div v-for="(mes, nombreMes) in datosAgrupadosEspecialistas" :key="nombreMes">
                    <p class="text-left" style="font-weight: 600; font-size: 1em; color: #0069A9">{{ nombreMes }}</p>
                    <div :class="{'cardCerradaEnCurso': comision.periodoActual && !comision.cardColapsada, 'cardAbierta': comision.cardColapsada}" v-for="(comision, index) in mes" :key="index" class="mb-2"  style="border: 1px solid #E8E8E8; border-radius: 15px; min-height: 75px;">
                      <div v-if="comision.periodoActual" class="pt-1 pb-1" style="left: 0px; top: 0px; border-radius: 15px 0px 15px 0px; background-color: #74D57D; color: white; width: 7%; font-size: 11px; font-weight: 500;">En curso</div>
                      <div class="d-flex align-items-center" :style="!comision.periodoActual ? 'min-height: 74px;' : ''">
                        <b-row class="w-100 w-100 pl-4" :class="comision.periodoActual ? 'pt-2' : ''"  style="font-size: .8em;">
                          <b-col>{{ comision.desde }}</b-col>
                          <b-col>{{ comision.hasta }}</b-col>
                          <b-col lg="2">{{ comision.periodo }}</b-col>
                          <!-- <b-col lg="2">{{ comision.ganador }}</b-col> -->
                          <b-col lg="2">{{ formatoMoneda(comision.COMISIONES) }}</b-col>
                          <b-col lg="2">{{ comision.fechaPago }}</b-col>
                        </b-row>
                       </div>
                        </div>
                  </div>
                </div>
              </div>
              </div>
          </div>
        </div>
      </div>

      <div v-if="tabSeleccionada == 1 && $localStorageService.can('NuevaComisionDetalle')" style="min-height: 500px;"> 
        <p class="text-left" style="font-weight: bold; color: #0069A9;">Detalle de comisiones ({{periodoActual}})</p>

        <b-row class="d-flex justify-content-between w-100">
          <b-col lg="6" md="12" sm="12">
            <div class="barras d-flex justify-content-center w-100" v-if="$localStorageService.can('filtro_dr_comision')" style="margin-top: 10px" ><!--  -->
              <b-form-input
                  class="input-filter"
                  v-model="buscador"
                  placeholder="Búsqueda de doctor por nombre"
                  type="text"
                  @keydown.enter.native="buscarEmpleados(2)"
              >
              </b-form-input>
              <b-button class="btn-extra-small" variant="info" @click="buscarEmpleados(2)">
                              <span>
                                <em class="buscar_svg" style="margin-top: 3px; height: 13px">
                                </em
                                ></span>
              </b-button>
            </div>

            <b-table
            v-if="doctores.length > 0"
            style="border-radius: 10px"
            :fields="fields"
            :items="doctores"
            :per-page="registrosDrPorPagina"
            :current-page="paginaActualDr"
            selectable
            @row-selected="buscarComisionesDoctor"
            responsive
          >
          </b-table>
          <b-pagination
                  v-if="doctores.length >= registrosDrPorPagina"
                  align="center"
                  v-model="paginaActualDr"
                  :total-rows="doctores.length"
                  :per-page="registrosDrPorPagina"
            ></b-pagination>
        
          </b-col>
          <b-col lg="6" md="12" sm="12">
            <div v-if="$localStorageService.can('NuevaComisionFiltroaDetalle')" class="d-flex justify-content-between align-items-center pl-3 pr-3 mt-2" style="height: 4vh; padding-bottom: 1%; background-color: #EBF9FF; border-radius: 20px;">
                <em class="filtros_svg" style="width: 15px;"></em>
                <div class="d-flex justify-content-start ">
                  <div class="d-flex" @click="mostrarClinicas()" v-b-tooltip.hover title="Filtrar por clinica">
                  <a class=" filtro" :class="nombreTiempoSeleccionado != '' ? 'filtroActivo' : 'filtroInactivo'" @click.prevent id="popover-clinicas" href="#" tabindex="0">{{ textoClínicas }}</a>
                  <em :class="showPopoverClinicas ? 'rotate-chevron' : ''" class="arrow_down_svg chevron-gris ml-2" style="width: 13px;"></em>

                </div>
                <b-popover target="popover-clinicas" triggers="focus" placement="bottom" :show.sync="showPopoverClinicas">
                  <div class="mt-2 barra-busqueda d-flex">
                    <b-form-input
                        class="input-filter"
                        size="sm"
                        v-model="busquedaClinica"
                        placeholder="Búsqueda de clínica"
                        @input="buscarClinicas"
                    ></b-form-input>

                    <b-button  size="sm" variant="info" class="mr-3 btn-extra-small">
                                    <span
                                    ><em class="buscar_svg" style="height: 16px; margin-top: 8%; margin-bottom: -3px;"></em
                                    ></span>
                    </b-button>
                  </div>
                  <div class="p-2">
                    <div class="d-flex mt-2">
                      <b-form-checkbox
                          v-model="todasClinicas"
                          name="todasClinicas"
                          @input="seleccionarTodasClinicas"
                      >
                      </b-form-checkbox>
                      <p style="font-size: .9em;">Seleccionar todas las clínicas ({{clinicasEmpleado.length}})</p>
                    </div>
                    <hr style="margin-top: 0px;"/>
                    <div v-if="resultadosBusqueda.length == 0 && busquedaClinica != ''">
                      <p>No se encontraron resultados</p>
                    </div>
                    <div v-else class="scrollable-container-comisiones">
                      <div class="d-flex" v-for="(clinica, index) in clinicasFiltradas" v-bind:key="index">
                        <b-form-checkbox
                            v-model="clinica.selected"
                        >
                        </b-form-checkbox>
                        <p style="font-size: .9em;">{{clinica.nombreClinica}}</p>
                      </div>
                    </div>

                  </div>
                  <div class="text-center">
                    <b-button variant="outline-info" @click="obtenerResumenComisiones()" size="sm">Aplicar</b-button>
                  </div>
                </b-popover>

                <div class="d-flex ml-4" @click="mostrarTiempos()" v-b-tooltip.hover title="Filtrar por tiempo">
                  <a class=" filtro" :class="nombreTiempoSeleccionado != '' ? 'filtroActivo' : 'filtroInactivo'" id="popover-tiempo-detalle" @click.prevent href="#" tabindex="0">Tiempo {{nombreTiempoSeleccionado != '' ? '(' + nombreTiempoSeleccionado + ')' : ''}}</a>
                  <em :class="showPopoverTiempo ? 'rotate-chevron' : ''" class="arrow_down_svg chevron-gris ml-2" style="width: 13px;"></em>
                </div>
                <b-popover target="popover-tiempo-detalle" variant="light" triggers="focus" :show.sync="showPopoverTiempo">

                  <div class="p-2">
                    <b-form-group class="text-left" style="width: 100%;">
                      <label>Tiempo</label>
                      <b-form-select
                          :options="listaTipoTiempoDetalle"
                          v-model="tipoTiempo"
                          text-field="nombreTiempo"
                          value-field="idTiempo">
                      </b-form-select>
                    </b-form-group>

                    <b-form-group v-if="tipoTiempo == 1" class="text-left">
                      <label>Periodo</label>
                      <b-form-select
                          :options="listaPeriodo"
                          v-model="tipoPeriodo"
                          text-field="nombrePeriodo"
                          value-field="idPeriodo">
                      </b-form-select>
                    </b-form-group>

                    <b-form-group v-if="tipoTiempo == 2 || tipoTiempo == 1" class="text-left">
                      <label>Mes</label>
                      <b-form-select
                          :options="listaMeses"
                          v-model="mesPeriodo"
                          text-field="nombreMes"
                          value-field="idMes">
                      </b-form-select>
                    </b-form-group>

                    <b-form-group v-if="tipoTiempo == 3">
                      <label>Fecha</label>
                      <b-form-datepicker
                          locale="es-MX"
                          v-model="fechaDia"
                          labelNoDateSelected="Fecha de filtrado"
                          :max="new Date()"
                      ></b-form-datepicker>
                    </b-form-group>

                    <div v-if="tipoTiempo == 4">
                      <b-form-group>
                        <label>Fecha inicio</label>
                        <b-form-datepicker
                            locale="es-MX"
                            v-model="fechaInicio"
                            labelNoDateSelected="Fecha de filtrado"
                            :max="new Date()"
                        ></b-form-datepicker>
                      </b-form-group>
                      <b-form-group>
                        <label>Fecha fin</label>
                        <b-form-datepicker
                            locale="es-MX"
                            v-model="fechaFin"
                            labelNoDateSelected="Fecha de filtrado"
                            :max="new Date()"
                        ></b-form-datepicker>
                      </b-form-group>
                    </div>
                    <b-form-group v-if="tipoTiempo == 1 || tipoTiempo == 2 " class="text-left">
                      <label>Año</label>
                      <b-form-select
                          :options="anios"
                          v-model="anioPeriodo"
                      >
                      </b-form-select>
                    </b-form-group>
                  </div>
                  <div class="text-center">
                    <!-- <b-button variant="outline-info" @click="obtenerDatos()" size="sm">Aplicar</b-button> -->
                    <b-button variant="outline-info" @click="obtenerResumenComisiones()" size="sm">Aplicar</b-button>
                  </div>
                </b-popover>
                </div>
            </div>
           
          </b-col>



        </b-row>
        
        <div class="d-flex justify-content-center mt-5">
          <div class="barras d-flex justify-content-center" v-if="$localStorageService.can('NuevaComisionBusquedaDetalle')" style="width: 50%; margin-top: 10px" ><!--  -->
            <b-form-input
                class="input-filter"
                v-model="filter"
                placeholder="Búsqueda por paciente o tratamiento"
                type="text"
                @input="filtrarComisiones($event)"
            >
            </b-form-input>
            <b-button class="btn-extra-small" variant="info">
                          <span>
                            <em class="buscar_svg" style="margin-top: 3px; height: 13px">
                            </em
                            ></span>
            </b-button>
          </div>
          <div>
            <b-button
                variant="success"
                v-b-tooltip.hover
                title="Generar excel"
                class="mt-3 ml-2 paddingbotones"
                style="border-radius: 10rem"
                responsive
                @click="exportarExcel()"
                :disabled="loader"
                v-if="$localStorageService.can('NuevaComisionExcel') && datosComisiones.length > 0"
            ><em class="excel icon-boton ml-1"></em><!--  -->
            </b-button>
          </div>

        </div>

        <div class="mt-5">
          <div >
            <div class="d-flex justify-content-start">
              <b-table-simple v-if="nivelPuestoID == 38 && ortodoncista == true && (tier == 1 || tier == 2)" small caption-top responsive bordered class="text-right" style="border-left: none !important; width: 40%;">
              <b-tbody>
                <b-tr>

                  <b-th class="text-right">Monto total comisiones</b-th>
                  <b-td>{{ montoTotalComisiones | monedaDecimal }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">Monto total bonos</b-th>
                  <b-td>{{ montoTotalBonos | monedaDecimal }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">Total</b-th>
                  <b-td>{{ montoTotal | monedaDecimal }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">Comisiones retenidas por adeudos</b-th>
                  <b-td>{{ montoComisionesRetenidas | monedaDecimal }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">Total a pagar</b-th>
                  <b-td>{{ sumaTotalAPagar | monedaDecimal }}</b-td>
                </b-tr>
                </b-tbody>
              </b-table-simple>

              <b-table-simple v-if="nivelPuestoID == 38 && ortodoncista == true && tier == 3" small caption-top responsive bordered class="text-right" style="border-left: none !important; width: 40%;">
              <b-tbody>
                <b-tr>
                  <b-th class="text-right">Monto total nueva comisión sesión</b-th>
                  <b-td>{{ montoTotalComisiones | monedaDecimal }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">Comisiones retenidas por adeudos</b-th>
                  <b-td>{{ montoComisionesRetenidas | monedaDecimal }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">Total a pagar</b-th>
                  <b-td>{{ sumaTotalAPagar | monedaDecimal }}</b-td>
                </b-tr>
                </b-tbody>
              </b-table-simple>


              <b-table-simple v-if="nivelPuestoID == 38 && ortodoncista == false && (tier == 1 || tier == 2)" small caption-top responsive bordered class="text-right" style="width: 40%;">
              <b-tbody>
                <b-tr>
                  <b-th class="text-right">Nueva comisión sesión</b-th>
                  <b-td>{{ montoTotalComisionesEspecialista | monedaDecimal }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">Monto total bono especial</b-th>
                  <b-td>{{ sumaBonoAdicional | monedaDecimal }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">Sumatoria del total</b-th>
                  <b-td>{{ montoTotal | monedaDecimal }}</b-td>
                </b-tr>
                </b-tbody>
              </b-table-simple>

              <b-table-simple v-if="nivelPuestoID == 42" small caption-top responsive bordered class="text-right" style="width: 40%;">
              <b-tbody>
                <b-tr>
                  <b-th class="text-right">Monto total nueva comisión sesión</b-th>
                  <b-td>{{ montoTotalComisionesEspecialista | monedaDecimal }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">Comisiones retenidas por adeudos</b-th>
                  <b-td>{{ montoComisionesRetenidas | monedaDecimal }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">Total a pagar</b-th>
                  <b-td>{{ sumaTotalAPagar | monedaDecimal }}</b-td>
                </b-tr>
                </b-tbody>
              </b-table-simple>


              <b-table-simple v-if="nivelPuestoID == 38 && ortodoncista == false && tier == 3" small caption-top responsive bordered class="text-right" style="width: 40%;">
              <b-tbody>
                <b-tr>
                  <b-th class="text-right">Monto total nueva comisión sesión</b-th>
                  <b-td>{{ montoTotalComisionesEspecialista | monedaDecimal }}</b-td>
                </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>

            <div style="min-height: 50vh">
              <b-table
              style="border-radius: 10px"
              :fields="fieldsTabla"
              :items="comisionesFiltradas"
              responsive
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
            
            >
              <template v-slot:cell(DESCUENTO_PROMOCION)="row">
                <span v-if="row.item.DESCUENTO_PROMOCION !== null && row.item.DESCUENTO_PROMOCION !== ''">
                  {{ row.item.DESCUENTO_PROMOCION }}%
                </span>
              </template>
              <template v-slot:cell(CALCULO_COMISION)="row">
                <span>
                  {{ row.item.CALCULO_COMISION | monedaDecimal}}
                </span>
              </template>
              <template v-slot:foot(PRECIO_TOTAL)="row">
                <i>{{ montoTotalPrecioTotal | monedaDecimal}}</i>
              </template>
              <template v-slot:cell(ESCANER)="row">
                <i>{{ row.item.ESCANER == true ? "Sí" : "No"}}</i>
              </template>
              <template v-slot:cell(NUEVA_COMISION)="row">
                <span>
                  {{ row.item.NUEVA_COMISION | monedaDecimal}}
                </span>
              </template>
              <template v-slot:cell(NUEVA_COMISION_N)="row">
                <span>
                  {{ row.item.NUEVA_COMISION_N | monedaDecimal}}
                </span>
              </template>
             
              <template v-slot:cell(TOTAL_BONOS)="row">
                <span>
                  {{ row.item.TOTAL_BONOS | monedaDecimal}}
                </span>
              </template>
              <template v-slot:cell(BONO_BRM)="row">
                <span>
                  {{ row.item.BONO_BRM | monedaDecimal}}
                </span>
              </template>
              <template v-slot:cell(TOTAL)="row">
                <span>
                  {{ row.item.TOTAL | monedaDecimal}}
                </span>
              </template>
            </b-table>
            <div v-if="itemsPaginados.length === 0" class="d-flex justify-content-center align-items-center" style="min-height: 20vh">
              <p>
                No se encontradon resultados.
              </p>
            </div>
            <b-pagination
                  v-if="comisionesFiltradas.length >= registrosPorPagina"
                  align="center"
                  v-model="paginaActual"
                  :total-rows="comisionesFiltradas.length"
                  :per-page="registrosPorPagina"
            ></b-pagination>
            </div>
          </div>
          
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Chart from "chart.js";
import XLSX from 'xlsx';


export default {
  name: "NuevoEsquemaComisiones",
  components: { Header },
  data() {
    return {
      tierHistorico: null,
      tier: null,
      registrosPorPagina: 20,
      paginaActual: 1,
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      datosComisionesNuevoEsquema: null,
      loading: false,
      fechaMaxima: null,
      datosResumenComisiones: null,
      filter: null,
      datosComisiones: [],
      montoTotalPrecioTotal: 0,
      montoTotalComision: 0,
      sumaBonoAdicional: 0,
      sumaTotal: 0,
      anioPeriodo: null,
      fechaDia: null,
      fechaInicio: null,
      fechaFin: null,
      mesPeriodo: null,
      tipoPeriodo: null,
      tipoTiempo: 2,
      listaPeriodo: [
        {
          idPeriodo: 1,
          nombrePeriodo: "Primera quincena"
        },
        {
          idPeriodo: 2,
          nombrePeriodo: "Segunda quincena"
        },
      ],
      listaTipoTiempoDetalle: [
        {
          idTiempo: 1,
          nombreTiempo: "Quincenal"
        },
        {
          idTiempo: 2,
          nombreTiempo: "Mensual"
        },
        {
          idTiempo: 3,
          nombreTiempo: "Diario"
        },
        {
          idTiempo: 4,
          nombreTiempo: "Personalizado"
        }
      ],
      listaTipoTiempoResumen: [
        {
          idTiempo: 2,
          nombreTiempo: "Mensual"
        },
  
      ],
      listaMeses: [
        {
          idMes: 1,
          nombreMes: "Enero"
        },
        {
          idMes: 2,
          nombreMes: "Febrero"
        },
        {
          idMes: 3,
          nombreMes: "Marzo"
        },
        {
          idMes: 4,
          nombreMes: "Abril"
        },
        {
          idMes: 5,
          nombreMes: "Mayo"
        },
        {
          idMes: 6,
          nombreMes: "Junio"
        },
        {
          idMes: 7,
          nombreMes: "Julio"
        },
        {
          idMes: 8,
          nombreMes: "Agosto"
        },
        {
          idMes: 9,
          nombreMes: "Septiembre"
        },
        {
          idMes: 10,
          nombreMes: "Octubre"
        },
        {
          idMes: 11,
          nombreMes: "Noviembre"
        },
        {
          idMes: 12,
          nombreMes: "Diciembre"
        },
      ],
      busquedaClinica: '',
      loader:false,
      showPopoverClinicas: false,
      showPopoverTiempo: false,
      textoClínicas: "",
      todasClinicas: true,
      clinicasEmpleado: [],
      diaInicio: null,
      diaFin: null,
      numPeriodo: null,
      fechaSeleccionada: null,
      periodoActual: '',
      tabSeleccionada: 0,
      opciones: [
        { descripcion: "Resumen", permiso: "NuevaComisionDashboard"},/*   */
        { descripcion: "Detalle", permiso: "NuevaComisionDetalle" },
      ],
          
      fieldsOG: [
        { key: "ID_RECIBO", label: "ID recibo" },
        { key: "FECHA_TX", label: "Fecha del tratamiento" },
        { key: "FECHA_CALCULO_N", label: "Fecha de cálculo" },
        { key: "ID_PACIENTE", label: "ID de paciente" },
        { key: "PACIENTE", label: "Nombre del paciente" },
        { key: "SESION", label: "Sesión" },
        { key: "TOTAL_SESIONES", label: "Total de sesiones" },
        { key: "ID_TRATAMIENTO", label: "ID del tratamiento" },
        { key: "TRATAMIENTO", label: "Nombre del tratamiento" },
        { key: "DIENTE", label: "Diente" },
        { key: "CLINICA", label: "Clínica" },
        { key: "PRECIO_TOTAL", label: "Precio total TX", formatter: this.$formatoMoneda },
        { key: "MOTIVO_RETENCION", label: "Motivo de retención" },
        { key: "P_COMISION", label: "Porcentaje de comisión" },
        { key: "NUEVA_COMISION", label: "Nueva comisión sesión" },
        { key: "FECHA_PAGO", label: "Fecha de pago" },
      ],
      fieldsEspecialista: [
      { key: "ID_RECIBO", label: "ID recibo" },
        { key: "FECHA_TX", label: "Fecha del tratamiento" },
        { key: "FECHA_CALCULO_N", label: "Fecha de cálculo" },
        { key: "ID_PACIENTE", label: "ID de paciente" },
        { key: "PACIENTE", label: "Nombre del paciente" },
        { key: "SESION", label: "Sesión" },
        { key: "TOTAL_SESIONES", label: "Total de sesiones" },
        { key: "ID_TRATAMIENTO", label: "ID del tratamiento" },
        { key: "TRATAMIENTO", label: "Nombre del tratamiento" },
        { key: "DIENTE", label: "Diente" },
        { key: "CLINICA", label: "Clínica" },
        { key: "PRECIO_TOTAL", label: "Precio total TX", formatter: this.$formatoMoneda },
        { key: "MOTIVO_RETENCION", label: "Motivo de retención" },
        { key: "P_COMISION", label: "Porcentaje de comisión" },
        { key: "NUEVA_COMISION", label: "Nueva comisión sesión" },
      ],
      fieldsEspecialistaOrtodoncista: [
      { key: "ID_RECIBO", label: "ID recibo" },
        { key: "FECHA_TX", label: "Fecha del tratamiento" },
        { key: "ID_PACIENTE", label: "ID de paciente" },
        { key: "PACIENTE", label: "Nombre del paciente" },
        { key: "SESION", label: "Sesión" },
        { key: "TOTAL_SESIONES", label: "Total de sesiones" },
        { key: "ID_TRATAMIENTO", label: "ID del tratamiento" },
        { key: "TRATAMIENTO", label: "Nombre del tratamiento" },
        { key: "CLINICA", label: "Clínica" },
        { key: "PRECIO_TOTAL", label: "Precio total TX", formatter: this.$formatoMoneda },
        { key: "MOTIVO_RETENCION", label: "Motivo de retención" },
        { key: "ESCANER", label: "¿Tiene escáner? Aplica únicamente para brackets" },
        { key: "P_COMISION", label: "Porcentaje de comisión" },
        { key: "NUEVA_COMISION", label: "Nueva comisión sesión" },
      ],
      hayResultados: true,
      resultadosBusqueda: [],
      anios: [],
      fcInicio: null,
      fcFin: null,
      idEmpleado: null,
      periodoInicial: "",
      nombreTiempoSeleccionado: "",
      nivelPuestoID: null,
      nivelPuestoIDHistorico: null,
      ortodoncista: null,
      ortodoncistaHistorico: null,
      sumaReferenciacion: 0,
      montoTotalComisiones: 0,
      montoTotalComisionesEspecialista: 0,
      montoTotalBonos: 0,
      montoTotal: 0,
      sumaTotalAPagar: 0,
      montoComisionesRetenidas: 0,
      buscador: null,
      buscadorHistorico:null,
      currentPage: 1,
      doctores: [],
      fields: [
        { key: "idEmpleado", label: "Id colaborador" },
        { key: "nombre", label: "Nombre de colaborador" },
      ],
      registrosDrPorPagina: 5,
      paginaActualDr: 1,
      busquedaGeneral: false,
    };
  },
  created() {
    this.setFirstAvailableSubTab();
    this.debug = this.$localStorageService.getDebug();
    this.obtenerPeriodoInicio();
    this.obtenerRangoInicial();
    var fechaActual = this.$moment();
    const nuevaFecha = fechaActual.add(2, 'months');
    this.fechaMaxima = nuevaFecha.format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    this.idEmpleado = this.$localStorageService.getIdEmpleado();

    this.obtenerHistorico(true);

    
    const diaActual = this.$moment().date();
    this.mesPeriodo = this.$moment().month() + 1;
    this.anioPeriodo = this.$moment().year();
    this.periodoActual = "Detalle de comisiones" + this.obtenerPeriodo();
    this.tipoTiempo = 1;
    this.tipoPeriodo = diaActual <= 15 ? 1 : 2;
    this.obtenerClinicasEmpleado(); 
    this.llenarAnios();
    
    this.obtenerDatos();
    this.nombreTiempoSeleccionado = '';
  },
  watch: {
    tabSeleccionada: async function (tab) {
      if(this.busquedaGeneral == false){
        if(tab == 0){
          this.limpiarFiltros();
          this.obtenerHistorico(true);
        }else if(tab == 1){
          const diaActual = this.$moment().date();
          this.tipoPeriodo = diaActual <= 15 ? 1 : 2;
          this.mesPeriodo = this.$moment().month() + 1;
          this.anioPeriodo = this.$moment().year();
          this.periodoActual = "Detalle de comisiones" + this.obtenerPeriodo();
          this.limpiarFiltros();
          /* this.obtenerDatos(); */
          this.obtenerResumenComisiones();
        }
      }else{
        if(tab == 0){
          await this.obtenerRangoInicial();
          var fechaActual = this.$moment();
          const nuevaFecha = fechaActual.add(2, 'months');
          this.fechaMaxima = nuevaFecha.format('YYYY-MM-DDTHH:mm:ss.SSSZ');
          this.idEmpleado = this.$localStorageService.getIdEmpleado();

          this.obtenerHistorico(true);
        }
      }
      
      
    },

    /* filter(newValue){
      if(newValue == '' || newValue == null){
        this.comisionesFiltradas = this.datosComisiones
      }else{
        this.comisionesFitradas = this.datosComisiones.filter(comision => {
          comision.includes(newValue)
        })
      }
    } */
  },
  computed: {
    fieldsTabla() {
      let columnas = null;

      if(this.nivelPuestoID == 42){ //odontologo
         columnas = [...this.fieldsOG];

      }else if(this.nivelPuestoID == 38){// especialista
        
        columnas = [...this.fieldsEspecialista];
        if(this.ortodoncista == false){ //especialista no ortodoncista
          if(this.tier == 1 || this.tier == 2){
            columnas.push(
              { key: "BONO_ADICIONAL", label: "Bono especial" },
              { key: "TOTAL", label: "Total" },
              { key: "FECHA_PAGO", label: "Fecha de pago" }
            )
          }else if(this.tier == null || this.tier == 3){
            
            columnas.push(
              { key: "FECHA_PAGO_N", label: "Fecha de pago" }
            )
          }         
        }else if(this.ortodoncista == true){  //especialista ortodoncista
          columnas = [...this.fieldsEspecialistaOrtodoncista];
          if (this.tier == 1 || this.tier == 2) {
            columnas.push(
              { key: "TOTAL_BONOS", label: "Bonos" },
              { key: "TOTAL", label: "Total comision"},
              { key: "FECHA_PAGO", label: "Fecha de pago" },
            )
          }else if(this.tier == null || this.tier == 3){ // ortodoncista con tier 3
            columnas.push(
              { key: "FECHA_PAGO_N", label: "Fecha de pago" }
            )
          }
          
        }
      }
  
      return columnas;
    },

    datosAgrupadosOG() {
      return this.agruparPorMes(this.datosResumenComisiones);
    },

    datosAgrupadosEspecialistas(){
      return this.agruparPorMesEspecialistas(this.datosResumenComisiones);
    },

    clinicasFiltradas() {
      return this.resultadosBusqueda.length > 0 ? this.resultadosBusqueda : this.clinicasEmpleado;
    },


    comisionesFiltradas() {
      if (this.filter == '' || this.filter == null) {
        return this.datosComisiones; 
      }
      return this.datosComisiones.filter((item) => {
        const filtroIDPaciente = item.ID_PACIENTE.toLowerCase().includes(this.filter.toLowerCase());
        const filtroNombrePaciente = item.PACIENTE.toLowerCase().includes(this.filter.toLowerCase());
        const filtroIDTratamiento = item.ID_TRATAMIENTO.toLowerCase().includes(this.filter.toLowerCase());
        const filtroNombreTratamiento = item.TRATAMIENTO.toLowerCase().includes(this.filter.toLowerCase());

        return filtroIDPaciente || filtroNombrePaciente || filtroIDTratamiento || filtroNombreTratamiento;
      })
    },

    itemsPaginados() {
      const inicio = (this.paginaActual - 1) * this.registrosPorPagina;
      return this.comisionesFiltradas.slice(inicio, inicio + this.registrosPorPagina);
    },
  },
  mounted() {

  },
  methods: {
    async buscarComisionesDoctor(items){
      this.doctores = [];
      this.busquedaGeneral = true;
      this.idEmpleado = items[0].idEmpleado;
      await this.obtenerClinicasEmpleado();
      this.obtenerResumenComisiones();
    },
    async buscarComisionesHistorico(items){
      this.doctores = [];
      this.idEmpleado = items[0].idEmpleado;
      this.busquedaGeneral = true;
      await this.obtenerRangoInicial();
      await this.obtenerClinicasEmpleado();
      this.obtenerHistorico(true);
    },

    buscarEmpleados(tab){
      const params = {
        pagina: this.currentPage,
        filtro: tab == 1 ? this.buscadorHistorico : this.buscador,
      };
      this.$http
        .post(this.$api + "colaboradores/obtenerDoctoresActivos", params)
        .then((response) => {
          this.rows = response.data.data.total;
          this.doctores = response.data.data.colaboradores;
        })
        .catch()
        .finally(() => {
          this.loaderColabAct = false;
        });
    },
    filtrarComisiones($event){
      if($event == '' || $event == null){
        this.comisionesFiltradas = this.datosComisiones
      }else{
        this.comisionesFitradas = this.datosComisiones.filter(comision => {
          comision.includes($event)
        })
      }
    },
 
    setFirstAvailableSubTab() {
      const tabs = this.opciones;
      const firstAvailableIndex = tabs.findIndex(
        (tab) =>
          this.$localStorageService.can(tab.permiso)
      );

      this.tabSeleccionada = firstAvailableIndex !== -1 ? firstAvailableIndex : 0; 
    },
  agruparPorMes(datos) {
    if(datos != null){
      const resultDatos= datos.reduce((result, item) => {
      
      const nombreMes = this.$moment(item.DESDE, 'DD/MM/YYYY').format('MMMM');

      if (!result[nombreMes]) {
        result[nombreMes] = [];
      }

      result[nombreMes].push(item);

      
      return result;
    }, {});
    
    return resultDatos;
    }
  },

  agruparPorMesEspecialistas(datos){
    if (datos == null) return {};

    const fechaActual = this.$moment().format('DD/MM/YYYY');
    const fechaActualMoment = this.$moment(fechaActual, 'DD/MM/YYYY');

    const result = datos.reduce((acc, item) => {
        const desde = this.$moment(item.DESDE, 'DD/MM/YYYY');
        const quincena = desde.date() <= 15 ? '1A QUINCENA' : '2A QUINCENA';
        const nombreMes = desde.format('MMMM');
        const año = desde.format('YYYY');
        const mes = desde.format('MM');
        
        if (!acc[nombreMes]) {
            acc[nombreMes] = {
                '1A QUINCENA': {
                    periodo: '1A QUINCENA',
                    COMISIONES: 0,
                    bonoEspecial: 0,
                    bonoReferenciacion: 0,
                    total: 0,
                    fechaPago: item.FECHA_PAGO,
                    desde: `01/${mes}/${año}`,
                    hasta: `15/${mes}/${año}`,
                    periodoActual: false,
                    cardColapsada: false
                },
                '2A QUINCENA': {
                    periodo: '2A QUINCENA',
                    COMISIONES: 0,
                    bonoEspecial: 0,
                    bonoReferenciacion: 0,
                    total: 0,
                    fechaPago: item.FECHA_PAGO,
                    desde: `16/${mes}/${año}`,
                    hasta: desde.endOf('month').format('DD/MM/YYYY'),
                    periodoActual: false,
                    cardColapsada: false
                }
            };
        }

        const quincenaData = acc[nombreMes][quincena];
        
        quincenaData.COMISIONES += parseFloat(Number(item.COMISIONES) || 0);
        quincenaData.bonoEspecial += parseFloat(item.BONO_ADICIONAL || 0);
        quincenaData.bonoReferenciacion += parseFloat(item.BONO_BRM || 0);
        quincenaData.fechaPago = item.FECHA_PAGO; 
        quincenaData.ganador = item.GANADOR;
        quincenaData.SALARIO_FIJO = Number(item.SALARIO_FIJO);
        
        const fechaInicioMoment = this.$moment(quincenaData.desde, 'DD/MM/YYYY');
        const fechaFinMoment = this.$moment(quincenaData.hasta, 'DD/MM/YYYY');
        const estaDentroDelRango = fechaActualMoment.isBetween(fechaInicioMoment, fechaFinMoment, null, '[]');
        
        if (estaDentroDelRango) {
            quincenaData.periodoActual = true;
        }

        return acc;
    }, {});

    const resultDatos = {};
    Object.keys(result).forEach(mes => {
        resultDatos[mes] = [result[mes]['1A QUINCENA'], result[mes]['2A QUINCENA']];
    });

    return resultDatos;
  },

    limpiarFiltros(){
      this.obtenerRangoInicial();
      this.nombreTiempoSeleccionado = "";
      this.obtenerHistorico(true);
      this.obtenerPeriodoInicio();
    },

    async obtenerRangoInicial(){
      const fechaActual = this.$moment();
      this.fcInicio = fechaActual.clone().subtract(2, 'months').startOf('month').startOf('day').format('YYYY-MM-DD');
      this.fcFin = fechaActual.clone().endOf('month').endOf('day').format('YYYY-MM-DD');
    },
    
    obtenerPeriodoInicio(){
    const fechaActual = this.$moment();
    const fechaInicio = fechaActual.clone().subtract(2, 'months');
    
    const nombreMesActual = fechaActual.format('MMMM');
    const nombreMesInicio = fechaInicio.format('MMMM');
    
    const anioInicio = fechaInicio.format('YYYY');
    
    const textoMeses = `${nombreMesInicio.toUpperCase()} - ${nombreMesActual.toUpperCase()} ${anioInicio}`;
    
    this.periodoInicial = textoMeses;
    },

    redondeoPorcentaje(comision){
      return Number(comision).toFixed(2);
    },

    seleccionarTiempo(){
      this.nombreTiempoSeleccionado = (this.listaTipoTiempoDetalle.find(objeto => objeto.idTiempo === this.tipoTiempo) || {}).nombreTiempo;
    },

    formatoMoneda(comision){
      const numeroEntero = Math.trunc(comision);
      return '$ ' + (numeroEntero >= 1000 ? numeroEntero.toLocaleString('en-US') : numeroEntero);
    },
    formatoMes(fechaString){
      const fecha = this.$moment(fechaString, 'DD/MM/YYYY');
      return fecha.format('MMMM');
    },

    exportarExcel() {
      this.loading = true;
      let datosExcel = [];
      this.nivelPuestoID = this.datosComisiones[0].NIVEL_PUESTO_ID;
      this.ortodoncista = this.datosComisiones[0].ORTODONCISTA == 'false' ? false : true;
     

this.datosComisiones.forEach(element => {
  let datos = null;
  let datosOrtodoncista = null;
  if(this.nivelPuestoID == 42 || (this.nivelPuestoID == 38 && !this.ortodoncista)){
    datos = {
        "ID recibo": element.ID_RECIBO != null ? element.ID_RECIBO : undefined,
        "Fecha del tratamiento": element.FECHA_TX != null ? this.$moment(element.FECHA_TX, 'DD/MM/YYYY').add(1, 'day').format("DD/MM/YYYY")  : undefined,
        "Fecha de cálculo": element.FECHA_CALCULO != null ? this.$moment(element.FECHA_CALCULO, 'DD/MM/YYYY').add(1, 'day').format("DD/MM/YYYY")  : undefined,
        "ID de paciente": element.ID_PACIENTE != null ? element.ID_PACIENTE : undefined,
        "Nombre del paciente": element.PACIENTE != null ? element.PACIENTE : undefined,
        "Sesión": element.SESION != null ? element.SESION : undefined,
        "Total de sesiones": element.TOTAL_SESIONES != null ? element.TOTAL_SESIONES : undefined,
        "ID del tratamiento": element.ID_TRATAMIENTO != null ? element.ID_TRATAMIENTO : undefined,
        "Nombre del tratamiento": element.TRATAMIENTO != null ? element.TRATAMIENTO : undefined,
        "Diente": element.DIENTE != null ? element.DIENTE : undefined,
        "Clínica": element.CLINICA != null ? element.CLINICA : undefined,
        "Precio total TX": element.PRECIO_TOTAL != null ? element.PRECIO_TOTAL : undefined,
        "Motivo de retención": element.MOTIVO_RETENCION != null ? element.MOTIVO_RETENCION : undefined,
        "Porcentaje de comisión": element.P_COMISION != null ? element.P_COMISION : undefined,
        "Nueva comisión sesión": element.NUEVA_COMISION != null ? element.NUEVA_COMISION : undefined,
      };
  }else{
    datosOrtodoncista = {
        "ID recibo": element.ID_RECIBO != null ? element.ID_RECIBO : undefined,
        "Fecha del tratamiento": element.FECHA_TX != null ? this.$moment(element.FECHA_TX, 'DD/MM/YYYY').add(1, 'day').format("DD/MM/YYYY") : undefined,
        "ID de paciente": element.ID_PACIENTE != null ? element.ID_PACIENTE : undefined,
        "Nombre del paciente": element.PACIENTE != null ? element.PACIENTE : undefined,
        "Sesión": element.SESION != null ? element.SESION : undefined,
        "Total de sesiones": element.TOTAL_SESIONES != null ? element.TOTAL_SESIONES : undefined,
        "ID del tratamiento": element.ID_TRATAMIENTO != null ? element.ID_TRATAMIENTO : undefined,
        "Nombre del tratamiento": element.TRATAMIENTO != null ? element.TRATAMIENTO : undefined,
        "Clínica": element.CLINICA != null ? element.CLINICA : undefined,
        "Precio total TX": element.PRECIO_TOTAL != null ? element.PRECIO_TOTAL : undefined,
        "Motivo de retención": element.MOTIVO_RETENCION != null ? element.MOTIVO_RETENCION : undefined,
        "¿Tiene escáner? Aplica únicamente para brackets": element.ESCANER == true ? 'Sí' : 'No',
        "Porcentaje de comisión": element.COMISION_APLICABLE != null ? element.COMISION_APLICABLE : undefined,
        "Nueva comisión sesión": element.NUEVA_COMISION != null ? element.NUEVA_COMISION : undefined,
      };
  }
      
      if (this.nivelPuestoID == 42) {
        datos["Fecha de pago"] = element.FECHA_PAGO != null ? element.FECHA_PAGO : undefined;
      } else if (this.nivelPuestoID == 38) {
        if (!this.ortodoncista) {
          if (this.tier == 1 || this.tier == 2) {
            datos["Bono especial"] = element.BONO_ADICIONAL != null ? element.BONO_ADICIONAL : undefined;
            datos["Total"] = element.TOTAL != null ? element.TOTAL : undefined;
            datos["Fecha de pago"] = element.FECHA_PAGO != null ? element.FECHA_PAGO : undefined;
          } else if (this.tier == null || this.tier == 3) {
            datos["Fecha de pago"] = element.FECHA_PAGO != null ? element.FECHA_PAGO : undefined;
          }
        } else {
          if (this.tier == 1 || this.tier == 2) {      
            datosOrtodoncista["Bonos"] = element.TOTAL_BONOS != null ? element.TOTAL_BONOS : undefined;
            datosOrtodoncista["Total comisión"] = element.TOTAL != null ? element.TOTAL : undefined;
            datosOrtodoncista["Fecha de pago"] = element.FECHA_PAGO != null ? element.FECHA_PAGO : undefined;
          } else if (this.tier == null || this.tier == 3) {
            datosOrtodoncista["Fecha de pago"] = element.FECHA_PAGO != null ? element.FECHA_PAGO : undefined;
          }
        }
      }

      if(this.nivelPuestoID == 42 || (this.nivelPuestoID == 38 && !this.ortodoncista)){
        datosExcel.push(datos);
      }else{
        datosExcel.push(datosOrtodoncista);
      }
    });

    let data = XLSX.utils.json_to_sheet(datosExcel, { raw: true });

    
    let columnasTipos = {};

    // obtiene el tipo de dato dinámicamente
    datosExcel.forEach((dato) => {
      Object.keys(dato).forEach(key => {
        const tipo = typeof dato[key];
        if (!columnasTipos[key] || (tipo === 'number' && columnasTipos[key] !== 's')) {
          columnasTipos[key] = tipo === 'number' ? 'n' : 's';
        }
      });
    });

    // asigna el tipo de dato a la celda
    for (let col in columnasTipos) {
      for (let i = 2; i <= datosExcel.length + 1; i++) {
        const celda = data[col + i];
        if (celda) {
          celda.t = columnasTipos[col];
        }
      }
    }

    const ultFila = this.datosComisiones.length + 2;
    data['N' + ultFila] = {
      v: "Total nueva comisión",
      t: "s"
    };
    data['O' + ultFila] = {
      v: this.montoTotalComision,
      t: "n"
    };

    const numColumnas = Object.keys(columnasTipos).length;

    // construye el rango de referencia dinámicamente
    const rangoRef = "A1:" + XLSX.utils.encode_col(numColumnas) + (datosExcel.length + 1);

    // asignar el rango de referencia
    data["!ref"] = rangoRef;

    const workbook = XLSX.utils.book_new();
    const filename = 'comisiones';
    XLSX.utils.book_append_sheet(workbook, data, "Nuevos");
    XLSX.writeFile(workbook, `${filename}.xlsx`);

    this.loading = false;


    },
    llenarAnios() {
      let inicio = 2024;
      while (inicio <= new Date().getFullYear()) {
        this.anios.push(inicio);
        inicio++;
      }
    },

    buscarClinicas(){
      this.resultadosBusqueda = this.clinicasEmpleado.filter(clinica => clinica.nombreClinica.toLowerCase().includes(this.busquedaClinica.toLowerCase()));
    },

    mostrarTiempos(){
      this.showPopoverTiempo = !this.showPopoverTiempo;
      if (this.showPopoverClinicas) {
        this.showPopoverClinicas = !this.showPopoverClinicas;
      }
    },

    mostrarClinicas(){
      this.showPopoverClinicas = !this.showPopoverClinicas;
      if (this.showPopoverTiempo) {
        this.showPopoverTiempo = !this.showPopoverTiempo;
      }
    },

    cantidadSeleccionados() {
      return this.clinicasEmpleado.filter(clinica => clinica.selected).length;
    },

    obtenerTextoClínicas() {
      this.textoClínicas = this.cantidadSeleccionados() === this.clinicasEmpleado.length ? 'Clínicas (Todas)' : `Clínicas (${this.cantidadSeleccionados()})`;
    },

    seleccionarTodasClinicas() {
      if(this.todasClinicas){
        this.clinicasEmpleado.forEach((itm) => {
          itm.selected = true;
        });
      }else{
        this.clinicasEmpleado.forEach((itm) => {
          itm.selected = false;
        });
      }
    },

    async obtenerClinicasEmpleado() {
      const parametros = {
        idEmpleado: this.idEmpleado
      };
      try {
        const response = await this.$http.post(this.$api + "colaboradores/obtener/clinicas", parametros);
        if (response.status === 200) {
          this.clinicasEmpleado = response.data.data.map((e) => ({
            ...e,
            selected: true
          }));
        }
      } catch (error) {
        console.error(error);
      }
    },


    obtenerHistorico(componenteCreado, tipoTiempo){
      this.loading = true;

      if(!componenteCreado){
        this.seleccionarTiempo();
        this.datosResumenComisiones.forEach((comision) => {
        comision.cardColapsada = false;
      });

       if(tipoTiempo != undefined){
        this.tipoTiempo = tipoTiempo;
      }


      this.periodoInicial = this.obtenerPeriodo();
      }
 
      let clinicasSeleccionadas = this.clinicasEmpleado.filter(clinica => clinica.selected === true).map(clinica => clinica.idClinica)

      const parametros = {
        idEmpleado: this.idEmpleado,
        fcInicio: this.fcInicio,
        fcFin: this.fcFin,
        idsClinica: clinicasSeleccionadas
      }

      this.$http
          .post(
              this.$api +
              "ws/compensaciones/historico_compensaciones", parametros
          ).then((response) => {
            const objRespuesta = JSON.parse(response.data.data);
            let lstColumnas = [];
              objRespuesta.resultSetMetaData.rowType.forEach(it => {
                lstColumnas.push(it.name)
              })
              this.datosResumenComisiones = objRespuesta.data.map(item => {
                return item.reduce((obj, valor, indice) => {
                  obj[lstColumnas[indice]] = valor;
                  return obj;
                }, {});
              });
              
              this.datosResumenComisiones = this.datosResumenComisiones.map((e) => {
                return { ...e, cardColapsada: false, periodoActual: false };
              })

              const fechaActual = this.$moment().format('DD/MM/YYYY');

              this.datosResumenComisiones.filter(objeto => {
                const fechaInicioMoment = this.$moment(objeto.DESDE, 'DD/MM/YYYY');
                const fechaFinMoment = this.$moment(objeto.HASTA, 'DD/MM/YYYY');

                const estaDentroDelRango =  this.$moment(fechaActual, 'DD/MM/YYYY').isBetween(fechaInicioMoment, fechaFinMoment, null, '[]');
                if (estaDentroDelRango) {
                    objeto.periodoActual = true;
                }
             
                return estaDentroDelRango;
              });

              this.nivelPuestoIDHistorico = this.datosResumenComisiones[0].NIVEL_PUESTO_ID;
              this.ortodoncistaHistorico = this.datosResumenComisiones[0].ORTODONCISTA == 'false' ? false : true;
              this.tierHistorico = this.datosResumenComisiones[0].TIER;
              
              
          }).catch((error) => {
            console.error(error)
          }).finally(() => {
            this.loading = false;
          })
    },

    obtenerResumenComisiones(){
      this.loading = true;
      this.seleccionarTiempo()

      this.obtenerTextoClínicas();
      this.periodoActual = this.obtenerPeriodo();

      
      this.montoTotalPrecioTotal = 0;
      this.sumaBonoAdicional = 0;
      this.sumaReferenciacion = 0;
      this.sumaTotal = 0;
      this.montoTotalComisiones = 0;
      this.montoTotalComisionesEspecialista = 0;
      this.montoTotalBonos = 0;
      this.montoTotal = 0;
      this.datosComisiones = [];
      this.montoComisionesRetenidas = 0;
      this.sumaTotalAPagar = 0;

      let clinicasSeleccionadas = this.clinicasEmpleado.filter(clinica => clinica.selected === true).map(clinica => clinica.idClinica)
      const parametros = {
        idEmpleado: this.idEmpleado,
        fcInicio: this.fcInicio.utc().startOf('day').toISOString(),
        fcFin: this.fcFin.utc().startOf('day').toISOString(),
        idsClinica: clinicasSeleccionadas
      }

      this.$http
          .post(
              this.$api +
              "ws/compensaciones/resumen_compensaciones", parametros
          )
          .then((response) => {
            if (response.data.data !== null && !response.data.data.includes("Error")) {

              
              this.datosComisiones = response.data.data;
          
                
              if (this.datosComisiones != null) {
                this.nivelPuestoID = this.datosComisiones[0].NIVEL_PUESTO_ID;
                this.ortodoncista = this.datosComisiones[0].ORTODONCISTA == 'false' ? false : true;
                this.tier = this.datosComisiones[0].TIER;

                this.datosComisiones.forEach(element => {
                  this.montoTotalPrecioTotal+= element.PRECIO_TOTAL != null ? Number(element.PRECIO_TOTAL.replace('$', '').trim()) : 0;
                  if(element.PRECIO_TOTAL != null){
                    this.montoTotalPrecioTotal+= element.PRECIO_TOTAL != null ? Number(element.PRECIO_TOTAL.replace('$', '').trim()) : 0;
                  }

                  this.sumaBonoAdicional += Number(element.BONO_ADICIONAL);
                  this.sumaReferenciacion += Number(element.BONO_BRM);

                  this.montoTotalComisiones += Number(element.NUEVA_COMISION);
                  this.montoTotalComisionesEspecialista += Number(element.NUEVA_COMISION)
                  this.montoTotalBonos += Number(element.TOTAL_BONOS);
                  this.montoTotal += Number(element.TOTAL);

                  if(element.MOTIVO_RETENCION != null){
                    this.montoComisionesRetenidas += Number(element.NUEVA_COMISION);
                  }


                });
                this.sumaTotalAPagar = (this.montoTotal - this.montoComisionesRetenidas);
              }
            }else if(response.data.data.includes("Error")){
              console.error(response.data.data)
            }
          }).finally(()=> {
            this.loading = false;
          })
    },

    obtenerPeriodo() {
      var textoPeriodo = "";
      const diasEnMes = this.$moment().month(this.mesPeriodo - 1).daysInMonth();
      const mes = this.$moment().month(this.mesPeriodo - 1).format('MMMM');
      let alDia = this.$moment(this.fechaDia)
   
      switch (this.tipoTiempo) {
        case 1:
          this.diaInicio = this.tipoPeriodo == 1 ? 1 : 16;
          this.diaFin = this.tipoPeriodo == 1 ? 15 : diasEnMes;

          this.fcInicio = this.$moment([this.anioPeriodo, this.mesPeriodo - 1, this.diaInicio])
          this.fcFin = this.$moment([this.anioPeriodo, this.mesPeriodo - 1, this.diaFin])

          textoPeriodo = "del " + this.diaInicio + " al " + this.diaFin + " de " + mes + ", " + this.anioPeriodo;
          break;
        case 2:
          this.fcInicio = this.$moment([this.anioPeriodo, this.mesPeriodo - 1, 1])
          this.fcFin = this.$moment([this.anioPeriodo, this.mesPeriodo - 1, diasEnMes])

          textoPeriodo =  mes + ", " + this.anioPeriodo;
          break;
        case 3:
          this.fcInicio = alDia;
          this.fcFin = alDia;

          textoPeriodo = "del día " + alDia.format("LL");
          break;
        case 4:
          var diaInicio = this.$moment(this.fechaInicio).date();
          var mesInicio = this.$moment(this.fechaInicio).format('MMMM');
          var diaFin = this.$moment(this.fechaFin).date();
          var mesFin = this.$moment(this.fechaFin).format('MMMM');
          var anio = this.$moment(this.fechaInicio).year();

          this.fcInicio = this.$moment(this.fechaInicio);
          this.fcFin = this.$moment(this.fechaFin);

          textoPeriodo = "del " + diaInicio + " de " + mesInicio + " al " + diaFin + " de " +  mesFin + ", " + anio;
          break;
        default:
          break;
      }
      return textoPeriodo;
    },

    seleccionarTab(index) {
      this.tabSeleccionada = index;
    },

    calcularPaso(fijo, productividad) {
      const maximo = Math.max(fijo, productividad);
      const minimo = Math.min(fijo, productividad);
      const rango = maximo - minimo;
      return Math.ceil(rango / 2);
    },

    crearGraficaBarraHorizontal(index, comision, nombreMes){
      const fijo = comision.SALARIO_FIJO;
      const productividad = comision.COMISIONES;
        /* this.datosResumenComisiones.forEach((comision, i) => {
          if (i !== index) {
            comision.cardColapsada = false;
          }
        }); */

       let element = document.getElementById("bar-chart-horizontal" + nombreMes + index);
       if(element != null){
      new Chart(document.getElementById("bar-chart-horizontal" + nombreMes + index), {
        type: 'horizontalBar',
        data: {
          labels: ["Productividad", "Fijo"],
          
          datasets: [
            {
              backgroundColor: ["#9ED3DC","#64999A"],
              data: [productividad,fijo]
            }
          ]
        },
        options: {
          legend: { display: false },
          scales: {
            xAxes: [{
            ticks: {
              callback: function(value) {
                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                },
                stepSize: this.calcularPaso(fijo, productividad)
            }
        }]
          }
        },
        });
       }
    }
  }
};
</script>

<style scoped>
  .margenPeriodoActual{
    margin-top: -1%;;
  }

  .filtroActivo{
    color: #0069A9 !important;
    font-size: .9em;
    font-weight: 500;
  }

  .filtroInactivo{
    color: #6a6a6a !important;
    font-size: .9em;
    font-weight: 400;
  }

  .icon-boton-filtro {
  margin: auto;
  height: 10px;
  display: block;
  margin-left: -6px;
}

.boton-inv-filtro {
  height: 22px;
  width: 1px;
  border-radius: 50rem;
  background-color: white;
  border-color: #3F9BD3;
/*   filter: drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.16)); */
}

.boton-inv-filtro:hover{
  padding-left: 12px;
  background-color: white;
  border-color: white;
}

.circuloBonoFijo {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #64999A; 
}

.circuloBonoProductividad{
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #9ED3DC; 
}

@media screen and (max-width: 993px) {
  .botonDetalle{
    margin-top: 3%;
  }
}

  .cardAbierta{
    border: 1px solid #B9E7EE;
    border-radius: 15px;
    background-color: #F9FEFF;
  }

  .cardCerradaEnCurso{
    border: 1px solid #B1E7B6 !important;
    border-radius: 15px;
  }

  .cardCerrada{
    border: 1px solid #B9E7EE !important;
    border-radius: 15px;
  }

  .iconoSinCumplir{
    filter: brightness(0) saturate(100%) invert(45%) sepia(31%) saturate(1508%) hue-rotate(317deg) brightness(101%) contrast(80%);
  }
  .colorFechaPagoCumplido{
    color: #1C558E;
  }

  .colorPagoCumplido{
    color: #61A5C2;
  }

  .colorPagoSinCumplir{
    color: #E65B5B;
  }

.icon-boton {
  margin: auto;
  height: 20px;
  display: block;
  margin-right: 1px;
  margin-left: -5px;
}

.boton-inv {
  height: 35px;
  width: 35px;
  border-radius: 50rem;
  background-color: white;
  border-color: #3F9BD3;
/*   filter: drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.16)); */
}

.boton-inv:hover{
  padding-left: 12px;
  background-color: white;
  border-color: white;
}

.rotate-chevron {
  transform: rotate(180deg);
}

.scrollable-container-comisiones{
  overflow-y: auto;
  max-height: 30vh;
}


.tabs {

  padding: 0;
  margin-left: 0px;
  width: 30%;
}

.tabs .tabs-nav ul {

  display: flex;
  list-style: none;
  left: 0;
  padding: 0;
}

.tabs .tabs-nav ul li {
  flex: 1 0 auto;
  margin: 0;
  border-bottom: 3px solid transparent;
}

.tabs .tabs-nav ul li a {
  display: block;

  border: none;
  color: #aaaaaa;
}

.tabs .tabs-nav ul li a:hover {
  /* al sobre poner el mouse */
  color: #369bda;
}

.tabs .tabs-nav ul li.active a {
  color: #0069a9;
  font-weight: 600;
}

.chevron-gris{
  filter: invert(57%) sepia(1%) saturate(376%) hue-rotate(68deg) brightness(89%) contrast(87%);
}

.cuadro-info{
  min-height: 100px;
  border-radius: 20px;
}

.titulo-cuadro{
  font-size: .8em;
}

.txt-parametro{
  font-weight: 600;
  font-size: 1.5em;
  margin-top: 1%;
}

.color-acumulado-comisiones{
  color: #429D75;
}

.color-px-atendidos{
  color: #26BBBB;
}

.color-tx-realizados{
  color: #2C94AB;
}

.div-graficos{
  border: 1px solid #D9D9D9;
  min-height: 220px;
  border-radius: 20px;
}

.barras {
  border-width: 1px;
  border-style: solid;
  border-color: #c2e7ff;
  background: #ffffff;
  margin-top: 0px;
  margin-right: 0px;
  margin-left: 0px;
  padding-right: 2%;
  padding-left: 1%;
  border-radius: 20px;
  text-align: left;
  align-items: center;
}

.btn-extra-small {
  padding: 0.15rem 0.4rem;
  font-size: 0.7rem;
  line-height: 1.5;
}

.barra-busqueda {
  border-width: 1px;
  border-style: solid;
  border-color: #c2e7ff;
  background: #ffffff;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 5px;
  border-radius: 20px;
  text-align: left;
  align-items: center;

  min-width: 50px !important;
}

</style>
